import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { DataService } from '../services/data.service';
import { PackageType } from 'src/app/models/packagetype';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TransportMode } from 'src/app/models/transportmode';
import { FormService } from 'src/app/services/form';
import { ProposalService } from 'src/app/services/proposal.service';
import { MultiSelectItem } from '@tesla/angular2-tesla-common/tesla-common';
import { PackageMaterial } from '../models/packagematerial';
import { ToastService } from '../services/toaster/toaster.service';
import { Constants } from '../core/constants';
import { LocalstorageService } from '../services/localstorage.service';
import { UnitOfMeasurement } from '../models/internal/unit-of-measurement';
import Helper from '../core/utility/helper';
import { Router, ActivatedRoute } from '@angular/router';
import { PackageLevelTemplate } from '../models/packageleveltemplate';
import cloneDeep from 'lodash/cloneDeep';
import { QueryPackageTemplatesForSupplierDTO } from '../models/internal/query-packagetemplates-forsupplier-dto';
import { QueryPackageTemplatesForPEDTO } from '../models/internal/query-packagetemplates-for-pe-dto';
import { BaseGridPage, BasePage } from '../core/basepages/allbasepages';
import { ComponentCanDeactivate } from '../core/interfaces/component-can-deactive.interface';
import { SearchFilter } from '../models/internal/searchfilter';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from '../app.settings';
import { TeslaAutocompleteComponent } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.component';
import { FormFileToBeUploaded } from '../models/internal/formfile-tobe-uploaded';
import { ProposalDocument } from '../models/proposal-document';
import { PackageTemplateFile } from '../models/package-template-file';
import { FileToBeUploaded } from '../models/internal/file-tobe-uploaded';
import { ProposalImage } from '../models/proposal-image';
import { AddPackageLevelTemplateSupplierDTO } from '../models/addpltsupplier-dto';
import { TslFileDrop } from '@tesla/ng-tds';
import { PackageTemplateSupCode } from '../models/package-template-supcode';

@Component({
    selector: 'app-packagelevel-template',
    templateUrl: './packagelevel-template.component.html',
    styleUrls: ['./packagelevel-template.component.scss'],
})
export class PackageLevelTemplateComponent extends BasePage implements OnInit, ComponentCanDeactivate {
    locStorage = Constants.localStorageKeys;
    isBeingReferenced = false;
    packageLevelTemplateId: string = null;
    finalpackageLevelTemplateId: string = null;
    isUpdateMode = false;
    packageLevelTemplateDTO: PackageLevelTemplate;
    globalUOM: UnitOfMeasurement = new UnitOfMeasurement();
    showSecondaryLevelTemplateCodes: boolean;
    preferredSecondaryTemplateList: any[];
    partNumbers: string[];
    supplierAssginmentMessage: string = '';
    supplierCodesList: string[] = [];
    searchSupplierURL: string;
    isReturnablePackageTypeSelected: boolean = false;
    isUpdateReturnablePackageTypeSelected: boolean = false;
    addClicked = false;
    addPackageLevelTemplateSupplierDTO: AddPackageLevelTemplateSupplierDTO = new AddPackageLevelTemplateSupplierDTO();
    PackageLevelTemplateForm: FormGroup;
    supplierInfoForm: FormGroup;
    @ViewChild('SupplierAutoComplete') SupplierAutoComplete: TeslaAutocompleteComponent;
    @Output() private formReady: EventEmitter<FormGroup> = new EventEmitter<
        FormGroup
    >();
    @ViewChild('fileDrop') fileDrop: TslFileDrop;
    loadedFiles: File[] = [];
    dimensionsAndWeightsForSaving = {
        ODLength: null,
        ODWidth: null,
        ODHeight: null,
        IDLength: null,
        IDWidth: null,
        IDHeight: null,
        TareWeight: null,
        MaxWeight: null,
        CollapsedHeight: null
    };
    public packageLevelList = [
        { Id: 1, Description: 'Primary' },
        { Id: 2, Description: 'Secondary' },
    ];
    public packageTypeList: PackageType[];
    public defaultPackageType: PackageType;
    public transportModeList: TransportMode[];
    public packageMaterialList: PackageMaterial[];
    public packageLevelTemplateFiles: PackageTemplateFile[];
    public packageLevelTemplateSupCodes: PackageTemplateSupCode[];
    SubmitClicked = false;
    selectedSourceTypes: MultiSelectItem[] = [];
    // public partNumbers: string;
    public formErrors = {
        PackageLevelId: '',
        PackageTypeId: '',
        TransportModeId: '',
        PackageMaterialId: '',
        EffectiveFrom: '',
        EffectiveTo: '',
        SourceTypeIds: '',
        ODLength: '',
        ODWidth: '',
        ODHeight: '',
        IDLength: '',
        IDWidth: '',
        IDHeight: '',
        TareWeight: '',
        MaxWeight: '',
        CollapsedHeight: '',
        ContainersPerLayer: '',
        BoxDesign: '',
        ColorCode: '',
        TeslaEquipmentCode: '',
        BurstStrength: '',
        ECT: '',
        FluteSize: '',
        ReturnRatio: '',
        EnoviaCode: '',
    };
    // Scalibility requirements on Material Type ['Corrugated Box' : 19 , 'Corrugated Pallet Box' : 23]
    scalabilityRequired = [19, 23];
    @Output() tabChangeRequested = new EventEmitter<number>();
    @Output() formUpdated = new EventEmitter<number>();
    myFilter = (d: Date): boolean => {
        const day = d.getDay();
        // Prevent Saturday and Sunday from being selected.
        return day !== 0 && day !== 6;
    }
    constructor(
        private dataService: DataService,
        private fb: FormBuilder,
        private proposalService: ProposalService,
        public formService: FormService,
        localstorageService: LocalstorageService,
        private toastService: ToastService,
        private readonly route: ActivatedRoute,
        logger: NGXLogger,
        appSettings: AppSettings,
        private router: Router
    ) {
        super(localstorageService, logger, appSettings);

        this.supplierInfoForm = this.fb.group({
            SupplierCode: [null]

        });
        this.PackageLevelTemplateForm = this.fb.group({
            Id: 0,
            UOMSystemId: [Constants.IMPERIAL_UOM_ID],
            PackageLevelId: [null],
            PackageTypeId: [null],
            TransportModeId: [null],
            PackageMaterialId: [null],
            IsShippable: [null],
            IsTeslaStandard: [false],
            EffectiveFrom: [null],
            EffectiveTo: [null],
            ODLength: [null, Validators.compose([
                Validators.required,
                Validators.pattern('[0-9]*(\.[0-9]{1,4})?')
            ])],
            ODWidth: [null, Validators.compose([
                Validators.required,
                Validators.pattern('[0-9]*(\.[0-9]{1,4})?')
            ])],
            ODHeight: [null, Validators.compose([
                Validators.required,
                Validators.pattern('[0-9]*(\.[0-9]{1,4})?')
            ])],
            IDLength: [null, Validators.compose([
                Validators.pattern('[0-9]*(\.[0-9]{1,4})?')
            ])],
            IDWidth: [null, Validators.compose([
                Validators.pattern('[0-9]*(\.[0-9]{1,4})?')
            ])],
            IDHeight: [null, Validators.compose([
                Validators.pattern('[0-9]*(\.[0-9]{1,4})?')
            ])],
            TareWeight: [null, Validators.compose([
                Validators.pattern('[0-9]*(\.[0-9]{1,4})?')
            ])],
            MaxWeight: [null, Validators.compose([
                Validators.pattern('[0-9]*(\.[0-9]{1,4})?')
            ])],
            CollapsedHeight: [null, Validators.compose([
                Validators.pattern('[0-9]*(\.[0-9]{1,3})?')
            ])],
            ContainersPerLayer: [null],
            BoxDesign: [null],
            ColorCode: [null],
            TeslaEquipmentCode: [null, Validators.maxLength(Constants.TeslaCodeEquipmentMaxLength)],
            BurstStrength: [null],
            ECT: [null],
            FluteSize: [null],
            ReturnRatio: [null],
            IsTeslaCreated: false,
            SupplierCode: [null],
            PreferredSecondaryTemplateId: [0],
            EnoviaCode: [null, Validators.maxLength(Constants.EnoviaCodeMaxLength)],
        });
        this.searchSupplierURL = this.appSettings.Packaging2APIUrl + '/externaldata/supplier/all';
    }


    ngOnInit() {
        this.route.paramMap.subscribe(params => {
            this.packageLevelTemplateId = params.get('id');
            if (this.packageLevelTemplateId) {
                this.isUpdateMode = true;
                this.getPackageLevelTemplate(this.packageLevelTemplateId);
            }
            this.getSecondaryLevelTemplateCodes();
            this.getPackageLevelTemplateFiles(this.packageLevelTemplateId);
            this.getPackageLevelTemplateSupCodes(this.packageLevelTemplateId);
        });


        var dateMaxValue = new Date('9999-12-31');
        var browserOffset  = dateMaxValue.getTimezoneOffset();
        dateMaxValue = new Date(dateMaxValue.setMinutes(+ browserOffset));

        this.PackageLevelTemplateForm.patchValue({
            EffectiveFrom: new Date(),
            EffectiveTo: dateMaxValue
        });

        if (this.IsSupplier) {
            this.PackageLevelTemplateForm.controls['SupplierCode'].setValue(this.localstorageService.retrieve(this.locStorage.CurrentSupplierCode));
        } else {
            this.PackageLevelTemplateForm.controls['IsTeslaCreated'].setValue(true);
        }
        this.proposalService.partInfoList.subscribe(parts => {
            this.partNumbers = Array.prototype.map.call(
                parts,
                s => s.PartNumber
            );
        });

        // this.buildForm();
        if (!this.packageTypeList || this.packageTypeList.length === 0) {
            this.dataService.getPackageTypes().subscribe((response: any) => {
                // this.partInfo = data
                if (response && response.Data != null) {
                    this.packageTypeList = response.Data;
                    if (this.IsSupplier && !this.isUpdateMode) {
                      this.defaultPackageType = this.packageTypeList.find(c => c.Id === Constants.ExpendablePackagingTypeId);
                      this.PackageLevelTemplateForm.controls['PackageTypeId'].setValue(this.defaultPackageType.Id);
                      this.PackageTypeChanged(this.defaultPackageType.Id);
                    }
                }
            });
        }
        if (!this.transportModeList || this.transportModeList.length === 0) {
            this.dataService.getTransportModes().subscribe((response: any) => {
                // this.partInfo = data
                if (response && response.Data != null) {
                    this.transportModeList = response.Data;
                }
            });
        }
        this.PackageLevelTemplateForm.valueChanges.subscribe(data => {
            this.formErrors = this.formService.validateForm(
                this.PackageLevelTemplateForm,
                this.formErrors,
                true
            );
            this.formUpdated.emit();
        });
        if (!this.isUpdateMode) {
            this.globalUOM = Helper.getUoMObject(Constants.IMPERIAL_UOM_ID);
        }
        this.formReady.emit(this.PackageLevelTemplateForm);
    }

    refreshToolTipText(code: string) {
        this.supplierAssginmentMessage = Constants[code];
    }
    onEmptySupplierCode(eventObj: any): void {
        this.PackageLevelTemplateForm.controls['SupplierCode'].patchValue(null);
        this.SupplierAutoComplete.list = [];
    }

    canDeactivate(): boolean {
        return (!this.PackageLevelTemplateForm.dirty || this.SubmitClicked);
    }

    getTemplateCodePrefix() {
        if (this.IsSupplier) {
            return this.localstorageService.retrieve(this.locStorage.CurrentSupplierCode) + Constants.TEMPLATE_PREFIX_HARDCODED_PKGPART;
        } else {
            return '';
        }
    }

    getTemplateCodeWithoutPrefix(templateCodeWithPrefix: string) {
        // remove prefix if string is not null and does contain prefix hardcoded part
        if (templateCodeWithPrefix && templateCodeWithPrefix.indexOf(Constants.TEMPLATE_PREFIX_HARDCODED_PKGPART) > 0) {
            const start = templateCodeWithPrefix.indexOf(Constants.TEMPLATE_PREFIX_HARDCODED_PKGPART) + Constants.TEMPLATE_PREFIX_HARDCODED_PKGPART.length;
            const templateCodeWithoutPrefix = templateCodeWithPrefix.substring(start);
            return templateCodeWithoutPrefix;
        }
        // return as is because it doesn't contain string of prefix pattern
        return templateCodeWithPrefix;
    }

    getPackageLevelTemplate(packageLevelTemplateId: string) {
        this.dataService.getPackageLevelTemplate(packageLevelTemplateId).subscribe((response: any) => {
            if (response && response.Data != null) {
                this.packageLevelTemplateDTO = new PackageLevelTemplate();
                this.packageLevelTemplateDTO = cloneDeep(response.Data);
                this.PackageLevelTemplateForm.patchValue(response.Data);

                this.isBeingReferenced = this.packageLevelTemplateDTO.IsBeingReferenced;
                //TMS-34676 show IDLength/IDWidth/IdHeight/collopsedheight in edit mode for returnables
                if (this.packageLevelTemplateDTO.PackageTypeId == Constants.ReturnablePackagingTypeId) {
                    this.isUpdateReturnablePackageTypeSelected = true;
                }
                this.PackageLevelTemplateForm.controls['Id'].setValue(this.packageLevelTemplateId);
                if (this.IsSupplier) {
                    let templateCode = this.PackageLevelTemplateForm.controls['TeslaEquipmentCode'].value;
                    templateCode = this.getTemplateCodeWithoutPrefix(templateCode);
                    this.PackageLevelTemplateForm.controls['TeslaEquipmentCode'].setValue(templateCode);
                }
                if(this.packageLevelTemplateDTO.PackageTypeId == 1) {
                    this.isReturnablePackageTypeSelected = true;
                }
                // if(this.packageLevelTemplateDTO.PackageLevelId == 1)
                // {
                //     this.getSecondaryLevelTemplateCodes();
                // }
                this.getMaterials(this.packageLevelTemplateDTO.PackageTypeId);
                this.globalUOM = Helper.getUoMObject(this.packageLevelTemplateDTO.UOMSystemId);
                // update measurements only if not default
                if (this.packageLevelTemplateDTO.UOMSystemId !== Constants.IMPERIAL_UOM_ID) {
                    this.UdpateGlobalUOM(this.packageLevelTemplateDTO.UOMSystemId);
                } else {
                    this.convertMesaurementsForSave();
                }
                this.convertedMeasurementsForDisplay();
            }
        });
    }

    GlobalUOMChanged(event: any) {
        this.UdpateGlobalUOM(event.value);
        this.convertedMeasurementsForDisplay();
    }

    UdpateGlobalUOM(id: number) {
        this.globalUOM = Helper.getUoMObject(id);
        this.updateMeansurements();
    }

    checkMaterial() {
        const materialId = this.PackageLevelTemplateForm.controls['PackageMaterialId'];
        if (this.scalabilityRequired.find(x => x == materialId.value) ? true : false) {
            this.PackageLevelTemplateForm.controls['FluteSize'].setValidators([Validators.required, Validators.min(1)]);
            this.PackageLevelTemplateForm.controls['BurstStrength'].setValidators([Validators.required, Validators.min(1)]);
        } else {
            this.PackageLevelTemplateForm.controls['FluteSize'].clearValidators();
            this.PackageLevelTemplateForm.controls['BurstStrength'].clearValidators();
        }
        this.PackageLevelTemplateForm.controls['FluteSize'].updateValueAndValidity({ emitEvent: false, onlySelf: false });
        this.PackageLevelTemplateForm.controls['BurstStrength'].updateValueAndValidity({ emitEvent: false, onlySelf: false });
    }

    updateMeansurements() {
        if ((this.dimensionsAndWeightsForSaving.ODHeight || this.dimensionsAndWeightsForSaving.ODLength || this.dimensionsAndWeightsForSaving.ODWidth
            || this.dimensionsAndWeightsForSaving.TareWeight || this.dimensionsAndWeightsForSaving.MaxWeight || this.dimensionsAndWeightsForSaving.IDHeight
            || this.dimensionsAndWeightsForSaving.IDWidth || this.dimensionsAndWeightsForSaving.IDHeight || this.dimensionsAndWeightsForSaving.CollapsedHeight)) {
            this.setValuesForConversionOrSaving();
        }
        Helper.updateUOMs(this.PackageLevelTemplateForm, 'ODLength', false, this.globalUOM);
        Helper.updateUOMs(this.PackageLevelTemplateForm, 'ODWidth', false, this.globalUOM);
        Helper.updateUOMs(this.PackageLevelTemplateForm, 'ODHeight', false, this.globalUOM);
        Helper.updateUOMs(this.PackageLevelTemplateForm, 'CollapsedHeight', false, this.globalUOM);
        Helper.updateUOMs(this.PackageLevelTemplateForm, 'IDLength', false, this.globalUOM);
        Helper.updateUOMs(this.PackageLevelTemplateForm, 'IDWidth', false, this.globalUOM);
        Helper.updateUOMs(this.PackageLevelTemplateForm, 'IDHeight', false, this.globalUOM);
        Helper.updateUOMs(this.PackageLevelTemplateForm, 'TareWeight', true, this.globalUOM);
        Helper.updateUOMs(this.PackageLevelTemplateForm, 'MaxWeight', true, this.globalUOM);
        this.convertMesaurementsForSave();
    }

    getMaterials(packageTypeId: number) {
        if (packageTypeId > 0) {
            this.packageMaterialList = [];
            this.dataService
                .getMaterialsByPackageType(packageTypeId)
                .subscribe((response: any) => {
                    if (response && response.Data != null && response.Data.length > 0) {
                        this.packageMaterialList = response.Data;
                    }
                    // else
                    // {
                    //     this.PackageLevelTemplateForm.controls['PackageMaterialId'].setValue(null);
                    // }
                });
        }
    }
    getSecondaryLevelTemplateCodes() {
        if (!this.preferredSecondaryTemplateList || this.preferredSecondaryTemplateList.length === 0) {
            // filter.ValueColumnName = "PackageLevelId";
            // filter.Values = ["2"];
            const isSupplier = this.localstorageService.retrieve(this.locStorage.IsSupplier);
            if (isSupplier) {
                const queryPackageTemplatesForSupplierDTO: QueryPackageTemplatesForSupplierDTO = new QueryPackageTemplatesForSupplierDTO();
                queryPackageTemplatesForSupplierDTO.SearchFilter = new SearchFilter();
                queryPackageTemplatesForSupplierDTO.SupplierCode = this.localstorageService.retrieve(this.locStorage.CurrentSupplierCode);

                this.dataService
                    .getPackageTemplatesListForSupplier(queryPackageTemplatesForSupplierDTO)
                    .subscribe((response: any) => {
                        if (response && response.Data != null) {
                            this.preferredSecondaryTemplateList = response.Data;
                        }
                    });
            } else {
                const queryPackageTemplatesForPEDTO: QueryPackageTemplatesForPEDTO = new QueryPackageTemplatesForPEDTO();
                queryPackageTemplatesForPEDTO.SearchFilter = new SearchFilter();
                this.dataService
                    .getPackageTemplatesListForPE(queryPackageTemplatesForPEDTO)
                    .subscribe((response: any) => {
                        if (response && response.Data != null) {
                            this.preferredSecondaryTemplateList = response.Data;
                        }
                    });
            }
        }
    }

    //tms-34676 mark isUpdateReturnablePackageTypeSelected as false for expendable selection
    PackageTypeChanged(id: number) {
        this.PackageLevelTemplateForm.controls['PackageMaterialId'].setValue(null);
        if (id > 0) {
            this.getMaterials(id);
        }
        if(this.packageTypeList){
          const packageTypeInfo = this.packageTypeList.find(f => f.Id == id);
          if (packageTypeInfo.Id == Constants.ReturnablePackagingTypeId) {
            this.isReturnablePackageTypeSelected = true;
          }
          else {
            this.isReturnablePackageTypeSelected = false;
            this.isUpdateReturnablePackageTypeSelected = false;
          }
        }

    }

    // PackageLevelChanged(id: number) {
    //     if(id == 1)
    //     {
    //         this.showSecondaryLevelTemplateCodes = true;
    //     this.getSecondaryLevelTemplateCodes();
    //     }
    //     else
    //     {
    //         this.preferredSecondaryTemplateList = [];
    //         this.showSecondaryLevelTemplateCodes = false;
    //     }
    // }

    TransportModeChanged(id: number) {
        // this.PackageLevelTemplateForm.controls['PackageMaterialId'].setValue(null);
        // let packageTypeId = this.PackageLevelTemplateForm.controls['PackageTypeId'].value;
        // if(id > 0 && packageTypeId > 0)
        // {
        //     this.getMaterials(packageTypeId);
        // }
    }
    PackageMaterialChanged(id: number) {
        const selectedMaterial = this.packageMaterialList.find(a => a.Id == id);
        this.PackageLevelTemplateForm.controls['IsShippable'].setValue(selectedMaterial.IsShippable);
        this.ValidateForm();
    }
    onFilterChange() { }

    createPackageLevelTemplate() {
        this.formService.markFormGroupTouched(this.PackageLevelTemplateForm);
        this.scrollToTop();
        this.ValidateForm();
        if (this.PackageLevelTemplateForm.valid) {
            // set template code to have a prefix in case of supplier
            if (this.IsSupplier) {
                let userEnteredTemplateCode = this.PackageLevelTemplateForm.controls['TeslaEquipmentCode'].value;
                userEnteredTemplateCode = this.getTemplateCodePrefix() + userEnteredTemplateCode;
                this.PackageLevelTemplateForm.controls['TeslaEquipmentCode'].patchValue(userEnteredTemplateCode);
            }
            this.SubmitClicked = true;
            if (this.PackageLevelTemplateForm.controls['UOMSystemId'].value !== Constants.IMPERIAL_UOM_ID) {
                // Value in db should always be in Imperial uom so reset all forms to Imperial before reading values for submit
                this.globalUOM = Helper.getUoMObject(Constants.IMPERIAL_UOM_ID);
                this.updateMeansurements();
            }
            this.setValuesForConversionOrSaving();
            // round ECT to integer
            this.PackageLevelTemplateForm.controls['ECT'].setValue(Math.round(this.PackageLevelTemplateForm.controls['ECT'].value));
            if (!this.isUpdateMode) {
                this.dataService
                    .createPackageLevelTemplate(this.PackageLevelTemplateForm.value)
                    .subscribe(data => {
                        // this.partInfo = data
                        if (data != null) {
                            this.toastService.success(
                                'Package Template ' + Constants.SUCCESS_SAVE_GENERIC
                            );
                            //this.packageLevelTemplateId = data.Data.Id;
                            this.finalpackageLevelTemplateId = data.Data.Id;
                        }

                        //tms-28072 case when any new docs uploaded or suppliercode, add records to database
                        this.uploadPackageTemplateFile(this.loadedFiles, this.finalpackageLevelTemplateId);
                        this.assignSupplierCodetoPLT(this.supplierCodesList, this.finalpackageLevelTemplateId);
                            this.router.navigate(['/packageleveltemplateList']);
                    });
            } else {


                if (this.PackageLevelTemplateForm.controls['PackageTypeId'].value == 1){
                    this.dataService.getWarningPackageLevelTemplate(this.PackageLevelTemplateForm.value)
                        .subscribe(count =>
                            {
                                var needsConfirm = count.Data > 0;
                                var confirmed = !needsConfirm;
                                if (needsConfirm) {
                                    var message = `This change will auto update ${count.Data} proposal(s) Do you want to continue?`
                                    if(confirm(message)) {
                                        confirmed = true;
                                    }
                                }

                                if (confirmed) {
                                    this.updateTemplate();
                                }
                            }
                            );
                } else {
                    this.updateTemplate();
                }

            }
            let templateCode = this.PackageLevelTemplateForm.controls['TeslaEquipmentCode'].value;
            templateCode = this.getTemplateCodeWithoutPrefix(templateCode);
            this.PackageLevelTemplateForm.controls['TeslaEquipmentCode'].setValue(templateCode);

            //  this.proposalForm.reset();
        } else {
            this.SubmitClicked = false;
        }
    }

    updateTemplate() {
        this.dataService
            .updatePackageLevelTemplate(this.PackageLevelTemplateForm.value)
            .subscribe(data => {
                // this.partInfo = data
                if (data != null) {
                    this.toastService.success(
                        'Package Template ' + Constants.SUCCESS_SAVE_GENERIC
                    );
                }

                //During update, if any new file or any suppliecode is added, save it in database
                this.uploadPackageTemplateFile(this.loadedFiles, this.PackageLevelTemplateForm.value.Id);
                this.assignSupplierCodetoPLT(this.supplierCodesList, this.PackageLevelTemplateForm.value.Id);
                this.router.navigate(['/packageleveltemplateList']);
            });
    }

    ValidateForm() {
        Helper.resetFormErrors(this.formErrors);
        // reset errors for each control only if required validation is not violated
        Object.keys(this.PackageLevelTemplateForm.controls).forEach(key => {
            const thisControl = this.PackageLevelTemplateForm.get(key);
            if (thisControl.errors && thisControl.errors.required === undefined) {
                thisControl.setErrors(null);
            }
        });
        this.checkMaterial();
        this.checkEffectiveDates();
        this.PackageLevelTemplateForm = Helper.ValidatePackageTemplateLevelFields(this.PackageLevelTemplateForm, this.formErrors, this.globalUOM);
        this.formErrors = this.formService.validateForm(
            this.PackageLevelTemplateForm,
            this.formErrors
        );
    }

    formatDate(date) {
        return Helper.formatDate(date);
    }

    checkEffectiveDates() {
        this.PackageLevelTemplateForm.controls['EffectiveFrom'].clearValidators();
        this.PackageLevelTemplateForm.controls['EffectiveTo'].clearValidators();

        if (!this.isReturnablePackageTypeSelected) {
            return;
        }

        let fromDate = new Date(this.PackageLevelTemplateForm.controls['EffectiveFrom'].value);
        var isEffectiveFromChanging = false; 
        if (this.packageLevelTemplateDTO && new Date(this.packageLevelTemplateDTO.EffectiveFrom).getTime() != fromDate.getTime()) {
            isEffectiveFromChanging = true;
        }
        let toDate = new Date(this.PackageLevelTemplateForm.controls['EffectiveTo'].value);
        var isEffectiveToChanging = false; 
        if(this.packageLevelTemplateDTO  &&  new Date(this.packageLevelTemplateDTO.EffectiveTo).getTime() != toDate.getTime()) {
            isEffectiveToChanging = true; 
        }
        var today = new Date();
        today.setMinutes(0);
        today.setHours(0);
        today.setSeconds(0);

        if (isEffectiveFromChanging && fromDate < today) {
            this.PackageLevelTemplateForm.controls['EffectiveFrom'].setErrors({DateLessThanToday: true});
            return;
        }

        if (isEffectiveFromChanging && this.packageLevelTemplateDTO.HasProposalsThatHaveAlreadyStarted && fromDate > today ){
            this.PackageLevelTemplateForm.controls['EffectiveFrom'].setErrors({FromDateGreaterThanConst: 'Effective From can\'t be changed as this template has proposals that have started' });
            return;
        }

        if (isEffectiveFromChanging && fromDate > new Date(this.packageLevelTemplateDTO.EffectiveFromConstraint)){
            this.PackageLevelTemplateForm.controls['EffectiveFrom'].setErrors({FromDateGreaterThanConst: 'Effective From has to be lower than ' + Helper.formatDate(new Date(this.packageLevelTemplateDTO.EffectiveFromConstraint)) });
            return;
        }

        if (isEffectiveToChanging && toDate < new Date(this.packageLevelTemplateDTO.EffectiveToConstraint)){
            this.PackageLevelTemplateForm.controls['EffectiveTo'].setErrors({ToDateBeforeConst:  'Effective To has to be greater than ' + Helper.formatDate(new Date(this.packageLevelTemplateDTO.EffectiveToConstraint)) });
            return;
        }

        if (toDate <= fromDate) {
            this.PackageLevelTemplateForm.controls['EffectiveTo'].setErrors({EffectiveFromIsBeforeEffectiveTo: true})
            return;
        }

    }

    convertMesaurementsForSave() {
        this.dimensionsAndWeightsForSaving.ODHeight = this.PackageLevelTemplateForm.controls['ODHeight'].value;
        this.dimensionsAndWeightsForSaving.ODLength = this.PackageLevelTemplateForm.controls['ODLength'].value;
        this.dimensionsAndWeightsForSaving.ODWidth = this.PackageLevelTemplateForm.controls['ODWidth'].value;
        this.dimensionsAndWeightsForSaving.CollapsedHeight = this.PackageLevelTemplateForm.controls['CollapsedHeight'].value;
        this.dimensionsAndWeightsForSaving.IDLength = this.PackageLevelTemplateForm.controls['IDLength'].value;
        this.dimensionsAndWeightsForSaving.IDWidth = this.PackageLevelTemplateForm.controls['IDWidth'].value;
        this.dimensionsAndWeightsForSaving.IDHeight = this.PackageLevelTemplateForm.controls['IDHeight'].value;
        this.dimensionsAndWeightsForSaving.TareWeight = this.PackageLevelTemplateForm.controls['TareWeight'].value;
        this.dimensionsAndWeightsForSaving.MaxWeight = this.PackageLevelTemplateForm.controls['MaxWeight'].value;
    }

    convertedMeasurementsForDisplay() {
        Helper.convertValueForDisplay(this.PackageLevelTemplateForm, this.dimensionsAndWeightsForSaving);
    }

    setValuesForConversionOrSaving() {
        Helper.setValuesInForm(this.PackageLevelTemplateForm, this.dimensionsAndWeightsForSaving);
    }

    displayEnoviaCode() {
        if (!this.IsSupplier && !this.IsLoggedInAsSupplier) {
            return true;
        }
        return false;
    }
    displayAttachments() {
        if ((this.IsSupplier || this.IsLoggedInAsSupplier) && (!this.isReturnablePackageTypeSelected)) {
            return false;
        }
        return true;
    }
    // TMS-29760 - Alter condition to make sure PE is not able to associate other suppliers for Supplier created Templates.
    showSupplierAssignmentsSection() {
        if ((this.IsSupplier || this.IsLoggedInAsSupplier) || (!this.PackageLevelTemplateForm.get('IsTeslaCreated').value)) {
            return false;
        }
        return true;
    }

    getSupplierCode() {
        return this.supplierInfoForm.controls['SupplierCode'].value;
    }
    addSupplierCodeList() {
        //TMS-29696 Before adding new Supplier code, update existing Supplier code list by calling API and then proceed
        this.dataService.getpackageLevelTemplateSupCode(this.packageLevelTemplateId).subscribe((response: any) => {
            if (response && response.Data != null) {
                this.packageLevelTemplateSupCodes = response.Data;

                this.addClicked = true;
                const supplierCode = this.getSupplierCode();

                // Check Existing supplier code list and Newly added Supplier code list
                if(this.supplierCodesList.includes(supplierCode) || this.packageLevelTemplateSupCodes.map(a => a.SupplierCode).includes(parseInt(supplierCode))){
                    this.toastService.error(
                        'Supplier code already associated'
                    );
                }
                else{
                    this.supplierCodesList.push(supplierCode);
                }
            }
        });
    }

    removeSupplierCodeList(supplierCode: string) {
        if(this.supplierCodesList.includes(supplierCode))
        {
            const indexValue = this.supplierCodesList.indexOf(supplierCode);
            this.supplierCodesList.splice(indexValue, 1);
        }
    }

    //tms-28072 get packagelevel files info based on packagetemplateId
    getPackageLevelTemplateFiles(packageLevelTemplateId: string) {
        this.dataService.getpackageLevelTemplateFiles(packageLevelTemplateId).subscribe((response: any) => {
            if (response && response.Data != null) {
                this.packageLevelTemplateFiles = response.Data;
            }
        });
    }

    getPackageLevelTemplateSupCodes(packageLevelTemplateId: string) {
        this.dataService.getpackageLevelTemplateSupCode(packageLevelTemplateId).subscribe((response: any) => {
            if (response && response.Data != null) {
                this.packageLevelTemplateSupCodes = response.Data;
            }
        });
    }

    //tms-28072 Maintain array to add/remove files
    onFileAdd(files) {
        if (!files.length) {
            this.loadedFiles = [];
        } else {
            var allowedExtensions = /(\.jpg|\.jpeg|\.docx|\.pdf|\.xlsx)$/i;
            var isValidExtension = true;
            files.forEach(element => {
                var filename = element.name;
                if (!allowedExtensions.exec(filename)) {
                    isValidExtension = false;
                }
                else {
                    this.loadedFiles = [...this.loadedFiles, ...element];
                }
            });

            if (!isValidExtension) {
                this.toastService.error(
                    'Unsupported file extension. Please re-try'
                );
            }
        }
    }

    removeFile(index) {
        this.loadedFiles.splice(index, 1);
    }

    /*
      //tms-28072 disable existing uploads in case user wants to remove attachments
      //tms-29695 update toast message
    */
    DeleteUploadedFile(id: number, packageTemplateId: string) {
        if (Helper.confirmPLTFileDeleteAction()) {
            this.dataService.deletePackageTemplateFile(id).subscribe((response: any) => {
                if (response != null && response.Success) {
                    this.toastService.success('File deleted successfully', true);
                    this.getPackageLevelTemplateFiles(packageTemplateId);
                } else {
                    this.toastService.error(
                        'Could not delete the file'
                    );
                }
            });
        }
    }

    uploadPackageTemplateFile(files: File[], packageTemplateId: string) {
        if (files.length > 0) {
            this.dataService.uploadPackageTemplateFile(files, packageTemplateId).subscribe();
        }
    }

    assignSupplierCodetoPLT(supplierCode: string[], id: any) {
        if (supplierCode != null && supplierCode.length != 0) {
            this.addPackageLevelTemplateSupplierDTO.supplierCodesList = supplierCode;
            this.addPackageLevelTemplateSupplierDTO.packageLevelTemplateId = id;
            this.dataService.assignPackageTemplateToSuppliers(this.addPackageLevelTemplateSupplierDTO).subscribe();
        }
    }

    //tms-29695 Update toast message
    DeleteSupCodes(id: number, packageTemplateId: string) {
        if (Helper.confirmPLTSupCodeDeleteAction()) {
            this.dataService.deletePackageTemplateSupCode(id).subscribe((response: any) => {
                if (response != null && response.Success) {
                    this.toastService.success('Supplier code deleted successfully', true);
                    this.getPackageLevelTemplateSupCodes(packageTemplateId);
                } else {
                    this.toastService.error(
                        'Could not delete the supplier code'
                    );
                }
            });
        }
    }

    //tms-29692 Allow users to download uploads in Edit mode
    downloadAttachments(PackageTemplateFileId: number) {
        this.dataService.getAttachmentFile(PackageTemplateFileId.toString()).subscribe((response: any) => {
            Helper.downloadAttachments(response['Data']['Base64String'], response['Data']['FileName'], "application/octet-stream;base64");
        });
    }
}
